import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import SelectInput from '@/common/components/SelectInput';
import { LAST_YEAR_MONTHS } from '@/common/constants/lastYearMonths';
import { Container, InputWrapper } from './SearchBar.styled';

const SearchBar = ({ hook }) => {
	return (
		<Container>
			<InputWrapper>
				<SelectInput
					name='Month'
					options={LAST_YEAR_MONTHS}
					color={Colors.darkBlue}
					width={50}
					setSelected={hook.setSelectedMonth}
					selected={hook.selectedMonth}
				/>
				<div>
					<ActionButton
						defaultText='Search'
						onClick={(e) => hook.hanldeSearch(e)}
					/>
				</div>
			</InputWrapper>
			<InputWrapper>
				{hook.paymentData && (
					<SelectInput
						showLabel={false}
						options={hook.consultantsFilterOption}
						color={Colors.darkBlue}
						width={100}
						selectWidth={850}
						setSelected={hook.setSelectedConsultant}
						selected={hook.selectedConsultant}
						multiple={true}
					/>
				)}
			</InputWrapper>
		</Container>
	);
};

export default SearchBar;
